import { NoSsr } from "@mui/base";
import { notEmpty } from "@product/scmp-sdk";
import { useAtomValue } from "jotai";
import { useRouter } from "next/router";
import { type FunctionComponent, useMemo } from "react";

import { config } from "~/data";
import { accountAtom } from "~/lib/account";
import { rosettaAtom } from "~/lib/rosetta";
import { pathname as homePathName } from "~/pages/home";
import { pathname as plusPathName } from "~/pages/plus";
import { pathname as plusLearnMorePathName } from "~/pages/plus/learnmore";

import { Container, SCMPPlusTabsList } from "./styles";

type Props = {
  className?: string;
  isPlus: boolean;
};

export const SCMPPlusTabs: FunctionComponent<Props> = ({ className, isPlus }) => {
  const router = useRouter();
  const { isLoggedIn } = useAtomValue(accountAtom);
  const asyncRosettaState = useAtomValue(rosettaAtom);

  const hasSCMPPlusAccess = asyncRosettaState?.result?.user?.hasSCMPPlusAccessRight ?? false;
  const plusTrialPath = `${config.rosetta.subscribeHost}/plus/trial`;

  const plusTabPath = useMemo(() => {
    if (plusLearnMorePathName === router.pathname) return plusLearnMorePathName;
    if (!isLoggedIn) return plusLearnMorePathName;

    if (!notEmpty(asyncRosettaState) || asyncRosettaState?.status === "loading") return "";
    if (!hasSCMPPlusAccess) return plusTrialPath;
    return plusPathName;
  }, [asyncRosettaState, hasSCMPPlusAccess, isLoggedIn, plusTrialPath, router.pathname]);

  return (
    <Container className={className}>
      <NoSsr>
        <SCMPPlusTabsList $isActive={!isPlus} $isPlus={isPlus} pathname={homePathName}>
          SCMP.COM
        </SCMPPlusTabsList>
        {plusTabPath && (
          <SCMPPlusTabsList $isActive={isPlus} $isPlus={isPlus} pathname={plusTabPath}>
            SCMP <i>PLUS</i>
          </SCMPPlusTabsList>
        )}
      </NoSsr>
    </Container>
  );
};

SCMPPlusTabs.displayName = "SCMPPlusTabs";
